import styled from 'styled-components'
import { Row } from 'reactstrap'
import { shade } from 'polished'
import { queries } from '~/constants/mediaQuery'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 15px;
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 25px;
`

export const Loading = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 8rem;
  background-color: rgba(0, 0, 0, 0.1);
`

export const RowContainer = styled(Row)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 0 15px;
`
export const NewRowContainer = styled(Row)`
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  /* justify-content: center; */
`

export const KeywordsHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 25px;
`

export const SessionHeroContainer = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  align-items: flex-end;
  gap: 32px;
  align-self: stretch;
  border-radius: 12px;
  background: #fff;
  margin-top: 36px;

  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    @media ${queries.less.md} {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  h2 {
    color: #767676;

    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .buttons {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    @media ${queries.less.md} {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`

export const KeywordsContainer = styled.div`
  margin-top: 36px;

  @media ${queries.less.md} {
    margin: 20px -1.2rem;
  }
`

export const ContentWrapper = styled.div`
  border: 1px solid #e4e9ec;
  border-radius: 8px;
  display: flex;
  min-height: 75vh;
  height: auto;
  background: #fff;
`

export const SubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  strong {
    font-size: 22px;
    color: #767676;
  }

  & > div:last-child {
    display: flex;
    gap: 10px;

    & > div {
      min-width: 160px;
    }
  }
`

export const LocationFilterLabel = styled.label`
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
`

export const Body = styled.div`
  padding: 25px 30px;
  width: 100%;
`

export const FilterPanelContainer = styled.div`
  background: #fff;
  border-right: 1px solid #e4e9ec;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;

  & > div:last-child {
    border: none;
  }
`

export const FilterSection = styled.div`
  padding: 25px 30px;
  border-bottom: 1px solid #efefef;
`

export const ButtonTemplate = styled.button`
  font-size: 14px;
  font-weight: 500;
  color: white;
  background-color: #776cf1;
  border-radius: 16px;
  padding: 10px 20px;
  text-decoration: none;
  height: auto;
  flex-grow: initial;
  align-items: center;
  display: flex;
  max-height: 34px;
  transition-duration: 0.2s;

  &:hover {
    background-color: ${shade(0.2, '#776cf1')};
    color: white;
  }

  svg {
    margin-right: 12px;
  }

  @media ${queries.less.xll} {
    position: fixed;
    top: calc(100vh - 60px);
    right: 10px;
    z-index: 5;
    font-size: 0;
    border-radius: 50%;
    min-height: 50px;
    min-width: 50px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      margin: 0;
      padding: 0;
    }
  }
`

export const DatePickerContainer = styled.div`
  display: flex;
  text-align: center;
  /* margin-bottom: 1.25rem; */
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;

  @media ${queries.less.xl} {
    width: 88%;
  }

  svg {
    position: absolute;
    left: 7px;
    pointer-events: none;
  }
`
